import { addToChainAfter, addToEndOfChain, addToStartOfChain, ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddProductApiParameter, Cart } from "@insite/client-framework/Services/CartService";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { chain, DispatchCompleteAddingProductToCart, LoadCart } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { addCartModifiedToLocalStorage } from "@NA/Utils/Utility";
import {addProductToCart} from "@NA/Overrides/Common/Utilities/CustomTracking";


type AddToCartParameter = {
    onError?: (error: string) => void;
} & AddProductApiParameter &
    HasOnSuccess<CartLineModel>;

type HandlerType = ApiHandler<AddToCartParameter, CartLineModel>;

export const PushAddToCartCompleteInLocalStorage: HandlerType = props => {    
    addCartModifiedToLocalStorage();
};

export const SendTrackingCustomAddProductToCart: HandlerType = props => {
    const product:CartLineModel = props.apiResult;
    if(product){
        addProductToCart(product, 'add_to_cart', props.getState().context.session);
    }
};

addToStartOfChain(chain, PushAddToCartCompleteInLocalStorage); // DispatchCompleteAddingProductToCart, 
addToEndOfChain(chain, SendTrackingCustomAddProductToCart);
